import { BordPhoto } from 'bord-design-system';
import { bordColorTheme } from 'styles/styles.constants';
import './BordProductImageWithBrand.scss';

interface IBordProductImageWithBrand {
  imageUrl?: string | null;
  brandImageUrl?: string | null;
}

/**
 * Muestra la foto del producto con el logo de la marca superpuesto en la esquina inferior derecha.
 * Si no hay URL de producto se usa el ícono por defecto de BordPhoto.
 * El logo de marca solo se renderiza si se recibe brandImageUrl.
 */
const BordProductImageWithBrand = ({ imageUrl, brandImageUrl }: IBordProductImageWithBrand) => (
  <div className="bordProductImageWithBrand">
    <BordPhoto
      url={imageUrl ?? undefined}
      size="s56"
      oneToneIconProps={{ variant: 'laptopPhoneSync', standardSize: 32 }}
    />
    {brandImageUrl && (
      <div className="brandBadge">
        <BordPhoto
          variant="circle"
          url={brandImageUrl}
          size="s32"
          oneToneIconProps={{ variant: 'bord', customWidth: '3.2rem', stroke: bordColorTheme.navyBlue[600] }}
          imageProps={{ style: { height: 'auto', width: 'auto', maxHeight: '65%', maxWidth: '65%' } }}
        />
      </div>
    )}
  </div>
);

export default BordProductImageWithBrand;
